import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const AuthNotLoginRoutes = (props) => {
  const userStore = useSelector((state) => state.userReducer);
  return userStore?.users?.token ? <Navigate to="/checkout" /> : <Outlet />;
};
const AuthOnlyUserRoutes = (props) => {
  const userStore = useSelector((state) => state.userReducer);
  return userStore?.users?.token ? <Outlet /> : <Navigate to="/" />;
};

const PermissionRoutes = ({ permission, adminType, permissions }) => {
  const adminStore = useSelector((state) => state.adminReducer);

  if (!adminStore) {
    return <Navigate to="/login" />;
  }

  // Allow superadmin access to everything
  if (adminType === "mackAdmin777" || adminType === "jackAdmin775") {
    return <Outlet />;
  }

  // Allow only if permission is explicitly granted
  if (permissions?.includes(permission)) {
    return <Outlet />;
  }

  // Access denied
  return <Navigate to="/" />;
};

export { AuthNotLoginRoutes, AuthOnlyUserRoutes, PermissionRoutes };
